export {
    isDeviceActivationIntent,
    isDeviceActivationQueue,
    isDeviceActivationSupportNumber,
} from "./device-activation/isActivation";
export { usePlatformGuideManager } from "./hooks";
